import { Controller } from '@hotwired/stimulus'
import { formatCurrency, formatAmount } from '../utils/currency'

export default class extends Controller {
  static targets = [
    'capitalInput',
    'rateInput',
    'durationInput',
    'capitalDisplay',
    'rateDisplay',
    'durationDisplay',
    'capitalFinal',
    'interests',
    'returns',
  ]

  connect() {
    this.#refresh()
  }

  update() {
    this.#refresh()
  }

  #refresh() {
    const { capital, rate, duration } = this.#readValues()
    this.#updateSliders(capital, rate, duration)
    this.#renderResults(capital, rate, duration)
  }

  #readValues() {
    return {
      capital: parseFloat(this.capitalInputTarget.value),
      rate: parseFloat(this.rateInputTarget.value),
      duration: parseFloat(this.durationInputTarget.value),
    }
  }

  #updateSliders(capital, rate, duration) {
    this.capitalDisplayTarget.textContent = formatAmount(capital)
    this.rateDisplayTarget.textContent = rate
    this.durationDisplayTarget.textContent = duration

    this.#updateFill(this.capitalInputTarget)
    this.#updateFill(this.rateInputTarget)
    this.#updateFill(this.durationInputTarget)
  }

  #renderResults(capital, rate, duration) {
    // Compound interest — annual rate converted to monthly, applied over duration in months
    const capitalFinal = capital * Math.pow(1 + rate / 100 / 12, duration)
    const interests = capitalFinal - capital
    const returns = capital === 0 ? 0 : (interests / capital) * 100

    this.capitalFinalTarget.textContent = formatCurrency(Math.round(capitalFinal))
    this.interestsTarget.textContent = formatCurrency(Math.round(interests), { signed: true })
    this.returnsTarget.textContent = `${returns.toFixed(1)} %`
  }

  #updateFill(input) {
    const min = parseFloat(input.min)
    const max = parseFloat(input.max)
    const value = parseFloat(input.value)
    const percent = ((value - min) / (max - min)) * 100
    input.style.setProperty('--fill', `${percent}%`)
  }
}
